import type { Moment } from '@this/lib/moment';
import moment from '@this/lib/moment';

export interface OptionPlanArgs {
  id: number;
  name: string;
  key?: string;
  created_at: string;
  updated_at: string;
}

class OptionPlan {
  id: number;
  name: string;
  key?: string;
  createdAt: Moment;
  updatedAt: Moment;

  constructor(args: OptionPlanArgs) {
    this.id = args.id;
    this.name = args.name;
    this.key = args.key;
    this.createdAt = moment(args.created_at);
    this.updatedAt = moment(args.updated_at);
  }
}

export const getOptionDisplayName = (name?: string, optionPlanId?: number | string): string => {
  return name || `オプション ${optionPlanId ?? ''}`.trim();
};

export default OptionPlan;
